"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ConfigContext = void 0;

var _preactCompat = require("preact-compat");

var ConfigContext = (0, _preactCompat.createContext)({
  contentTypeConfig: {
    assignModerator: false,
    attachmentsTopic: false,
    attachmentsReplies: false,
    bestAnswer: false,
    changeAuthor: false,
    convertToArticle: false,
    convertToConversation: false,
    convertToIdea: false,
    convertToProductUpdate: false,
    convertToQuestion: false,
    copyTopic: false,
    featuredImage: false,
    forum: false,
    ideaStatus: false,
    like: false,
    markAsUnread: false,
    moderationLabel: false,
    moveReplyToExistingTopic: false,
    promoteReplyToNewTopic: false,
    moveTopicToExistingTopic: false,
    pending: false,
    pendingReply: false,
    pinReply: false,
    poll: false,
    productAreas: false,
    publicLabel: false,
    spam: false,
    spamReply: false,
    sticky: false,
    trash: false,
    trashReply: false,
    versionHistory: false,
    vote: false,
    highlightReply: false,
    bugStatus: false,
    createJiraTicket: false
  },
  moderationConfig: {
    contentHelpfulness: false,
    escalate: false,
    escalateReply: false,
    ip: false,
    profile: false,
    subscribe: false,
    userView: false,
    userBan: false,
    userEdit: false,
    postFields: false
  }
});
exports.ConfigContext = ConfigContext;
var _default = ConfigContext;
exports.default = _default;